import { render, staticRenderFns } from "./TelcoFormGeneral.vue?vue&type=template&id=27ac28b4&"
import script from "./TelcoFormGeneral.vue?vue&type=script&lang=ts&"
export * from "./TelcoFormGeneral.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports